/**
 * Calendar utility functions and constants
 */

// Weekday keys for mapping day index to name
export const weekdayKeys = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
];

export const formatLocalDateKey = (date) => {
  if (!date) return "";
  const offset = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  return offset.toISOString().split("T")[0];
};

export const normalizeDate = (date) => {
  if (!date) return null;
  const newDate = new Date(date);
  newDate.setHours(0, 0, 0, 0);
  return newDate;
};

// Format date range for display
export const formatDateRange = (startDate, endDate) => {
  if (!startDate) return "";

  const start = startDate instanceof Date ? startDate : new Date(startDate);
  if (!endDate) return formatDateForDisplay(start);

  const end = endDate instanceof Date ? endDate : new Date(endDate);

  return `${formatDateForDisplay(start)} au ${formatDateForDisplay(end)}`;
};

// Format a single date for display in French locale
export const formatDateForDisplay = (date, options = {}) => {
  if (!date) return "";

  const dateObj = date instanceof Date ? date : new Date(date);

  const defaultOptions = {
    day: "numeric",
    month: "long",
    year: "numeric",
  };

  return dateObj.toLocaleDateString("fr-FR", { ...defaultOptions, ...options });
};
